(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heading-text-image-slider"]) return;
  try {
    

jQuery(document).ready(function($){
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
         centerMode: true,
      fade: true,
      asNavFor: '.slider-nav'
    });
    
   

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-blogs"]) return;
  try {
    
  (function() {
    var section = document.querySelector('.be-blog-index[data-section-id="{{ section.id }}"]');

    if (!section) {
      return;
    }

    var rails = section.querySelectorAll('[data-blog-rail]');

    rails.forEach(function(rail) {
      var heading = rail.previousElementSibling;

      if (!heading) {
        return;
      }

      var prevButton = heading.querySelector('[data-rail-prev]');
      var nextButton = heading.querySelector('[data-rail-next]');
      var scrollAmount = function() {
        return Math.max(rail.clientWidth * 0.82, 280);
      };

      if (prevButton) {
        prevButton.addEventListener('click', function() {
          rail.scrollBy({ left: scrollAmount() * -1, behavior: 'smooth' });
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function() {
          rail.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
